import BicGroupPage from '@/pages/bic/BicGroupPage.vue'
import BicPage from '@/pages/bic/BicPage.vue'
import BicDetails from '@/pages/bic/BicDetails.vue'
import BicGroupDetails from '@/pages/bic/BicGroupDetails.vue'
import BICOnusList from '@/pages/biconus/BICOnusList.vue'
import BICOnusDetails from '@/pages/biconus/BICOnusDetails.vue'
import BICOnusForm from '@/pages/biconus/BICOnusForm.vue'

export default [
  {
    path: '/bic/bicGroup/:id',
    component: BicGroupPage,
    props: true
  },
  {
    path: '/bic/bic/:idBicGroup',
    component: BicPage,
    props: true
  },
  {
    path: '/bic/bic/:mode/:idBic',
    component: BicDetails,
    props: true
  },
  {
    path: '/bic/bicGroup/:mode/:idBicGroup',
    component: BicGroupDetails,
    props: true
  },
  {
    path: '/biconus',
    component: BICOnusList,
    props: true
  },
  {
    path: '/biconus/:mode/:id',
    component: BICOnusDetails,
    props: true
  }
]
